<script lang="ts">
  import UpcomingPayoutDetail from '../../components/charity/payout/upcoming-detail.svelte';

  export let params: { id: string };
</script>

<UpcomingPayoutDetail {params} />

